import React from 'react';

import ReactDOM from 'react-dom/client';

import * as Netfunnel from '@ecp/common/src/utils/netfunnel.d.ts';
import { getExpiredLocalStorage } from '@ecp/common/src/utils/utils';
import { setActionId } from '@ecp/common/src/utils/netfunnelUtils';

import App from './App';
import reportWebVitals from './reportWebVitals';

function rootRender() {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <>
      <App />
    </>
  );
}

let action_id = setActionId();

let netfunnel_pass = getExpiredLocalStorage('netfunnel_pass');

if (netfunnel_pass && netfunnel_pass == action_id) rootRender(); // 넷퍼넬 통과후 3시간이내 접속한 사용자는 패스시킴 => 1분으로 변경
else {
  Netfunnel.NetFunnel_Action({}, () => {
    rootRender();
  });
}

reportWebVitals();
